import {z} from 'zod'
import {SubscriptionFeatures} from './SubscriptionFeatures.js'

export const SubscriptionTier = z.object({
  tier: z.enum(['none', 'starter', 'basic', 'pro']),
  canUpgrade: z.boolean(),
  features: SubscriptionFeatures,
})

export type SubscriptionTier = z.infer<typeof SubscriptionTier>
